import { Component, inject, signal } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { MatTabsModule } from '@angular/material/tabs';
import { MatChipsModule } from '@angular/material/chips';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from "@angular/material/card";
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { Users } from '@app/users/users';
import { Tickets } from '@app/tickets/tickets';
import { AppService } from '@app/app.service';
import { Kpi } from '@app/models/kpi.model';
import { Settings } from '@app/settings/settings';

@Component({
  selector: 'app-dashboard',
  imports: [
    MatTabsModule,
    MatChipsModule,
    RouterModule,
    MatButtonModule,
    MatCardModule,
    MatProgressSpinner,
    Users,
    Tickets,
    Settings,
],
  standalone: true,
  templateUrl: './dashboard.html',
  styleUrl: './dashboard.scss',
})
export class Dashboard {

  selectedTabIndex = signal(0);

  private breakpointObserver = inject(BreakpointObserver);

  isMobile = signal(false);
  loading = signal(true);
  
  usersCount = signal(0);
  ticketsCount = signal(0);

  constructor(
    private appService: AppService,
  ) {
      this.breakpointObserver
        .observe(['(max-width: 768px)'])
        .subscribe(result => {
          this.isMobile.set(result.matches);
      });
  }

  ngOnInit(): void {
    // Restore selected tab from localStorage
    const savedTab = localStorage.getItem('dashboard_selected_tab_index');

    if (savedTab !== null) {
      this.selectedTabIndex.set(Number(savedTab));
    }

    this.getDashboardKpiCounts();
  }

  getDashboardKpiCounts(): void {
    this.loading.set(true);

    this.appService.getDashboardKpi().subscribe({
      next: (res) => {
        const kpi: Kpi = res.data;
        this.usersCount.set(kpi.users_count);
        this.ticketsCount.set(kpi.tickets_count);
        this.loading.set(false);
      },
      error: () => {
        this.loading.set(false);
      }
    });
  }

  onTabChange(index: number): void {
    this.selectedTabIndex.set(index);
    localStorage.setItem('dashboard_selected_tab_index', String(index));
  }

}
